import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
  server: {
    // This is optional because it's only used in development.
    // See https://next-auth.js.org/deployment.
    NEXTAUTH_URL: z.string().url().optional(),
    AUTH_SECRET: z.string().min(1),
    GOOGLE_CLIENT_ID: z.string().min(1).optional(),
    GOOGLE_CLIENT_SECRET: z.string().min(1).optional(),
    DISCORD_CLIENT_ID: z.string().optional(),
    DISCORD_CLIENT_SECRET: z.string().optional(),
    GITHUB_OAUTH_TOKEN: z.string().min(1).optional(),
    DATABASE_URL: z.string().min(1),
    GMAIL_USER: z.string().min(1).optional(),
    GMAIL_APP_PASSWORD: z.string().min(1).optional(),
    EMAIL_FROM: z.string().min(1).optional(),
    STRIPE_API_KEY: z.string().min(1).optional(),
    STRIPE_WEBHOOK_SECRET: z.string().min(1).optional(),
    AWS_ENDPOINT_URL_S3: z.string().optional(),
    AWS_ACCESS_KEY_ID: z.string().optional(),
    AWS_SECRET_ACCESS_KEY: z.string().optional(),
    AWS_REGION: z.string().optional(),
    AWS_BUCKET_NAME: z.string().optional(),
    GEMINI_API_KEY: z.string().optional(),
    PAYMENTS_ENABLED: z.enum(["true", "false"]).default("false"),
    NOWPAYMENTS_MODE: z.enum(["sandbox", "live"]).default("sandbox"),
    NOWPAYMENTS_API_KEY: z.string().min(1).optional(),
    NOWPAYMENTS_IPN_SECRET: z.string().min(1).optional(),
    NOWPAYMENTS_IPN_CALLBACK_URL: z.string().url().optional(),
    NOWPAYMENTS_ALLOWED_CURRENCIES: z
      .string()
      .default("btc,eth,ltc,sol,usdttrc20,usdtbsc"),
    NOWPAYMENTS_SANDBOX_CASE: z.string().min(1).optional(),
    NOWPAYMENTS_ACCEPT_SANDBOX_SYNTHETIC_FINISHED: z
      .enum(["true", "false"])
      .default("false"),
    PAYMENT_RECONCILIATION_SECRET: z.string().min(16).optional(),
    CRON_SECRET: z.string().min(16).optional(),
    ADMIN_ALERT_EMAIL: z.string().email().optional(),
  },
  client: {
    NEXT_PUBLIC_APP_URL: z.string().min(1),
    NEXT_PUBLIC_STRIPE_PRO_MONTHLY_PLAN_ID: z.string().min(1).optional(),
    NEXT_PUBLIC_STRIPE_PRO_YEARLY_PLAN_ID: z.string().min(1).optional(),
    NEXT_PUBLIC_STRIPE_BUSINESS_MONTHLY_PLAN_ID: z.string().min(1).optional(),
    NEXT_PUBLIC_STRIPE_BUSINESS_YEARLY_PLAN_ID: z.string().min(1).optional(),
  },
  runtimeEnv: {
    NEXTAUTH_URL: process.env.NEXTAUTH_URL,
    AUTH_SECRET: process.env.AUTH_SECRET,
    GOOGLE_CLIENT_ID: process.env.GOOGLE_CLIENT_ID,
    GOOGLE_CLIENT_SECRET: process.env.GOOGLE_CLIENT_SECRET,
    DISCORD_CLIENT_ID: process.env.DISCORD_CLIENT_ID,
    DISCORD_CLIENT_SECRET: process.env.DISCORD_CLIENT_SECRET,
    GITHUB_OAUTH_TOKEN: process.env.GITHUB_OAUTH_TOKEN,
    DATABASE_URL: process.env.DATABASE_URL,
    GMAIL_USER: process.env.GMAIL_USER,
    GMAIL_APP_PASSWORD: process.env.GMAIL_APP_PASSWORD,
    EMAIL_FROM: process.env.EMAIL_FROM,
    GEMINI_API_KEY: process.env.GEMINI_API_KEY,
    PAYMENTS_ENABLED: process.env.PAYMENTS_ENABLED,
    NOWPAYMENTS_MODE: process.env.NOWPAYMENTS_MODE,
    NOWPAYMENTS_API_KEY: process.env.NOWPAYMENTS_API_KEY,
    NOWPAYMENTS_IPN_SECRET: process.env.NOWPAYMENTS_IPN_SECRET,
    NOWPAYMENTS_IPN_CALLBACK_URL: process.env.NOWPAYMENTS_IPN_CALLBACK_URL,
    NOWPAYMENTS_ALLOWED_CURRENCIES: process.env.NOWPAYMENTS_ALLOWED_CURRENCIES,
    NOWPAYMENTS_SANDBOX_CASE: process.env.NOWPAYMENTS_SANDBOX_CASE,
    NOWPAYMENTS_ACCEPT_SANDBOX_SYNTHETIC_FINISHED:
      process.env.NOWPAYMENTS_ACCEPT_SANDBOX_SYNTHETIC_FINISHED,
    PAYMENT_RECONCILIATION_SECRET: process.env.PAYMENT_RECONCILIATION_SECRET,
    CRON_SECRET: process.env.CRON_SECRET,
    ADMIN_ALERT_EMAIL: process.env.ADMIN_ALERT_EMAIL,
    NEXT_PUBLIC_APP_URL:
      process.env.NEXT_PUBLIC_APP_URL ??
      (process.env.VERCEL_URL
        ? `https://${process.env.VERCEL_URL}`
        : undefined),
    // Stripe
    STRIPE_API_KEY: process.env.STRIPE_API_KEY,
    STRIPE_WEBHOOK_SECRET: process.env.STRIPE_WEBHOOK_SECRET,
    NEXT_PUBLIC_STRIPE_PRO_MONTHLY_PLAN_ID:
      process.env.NEXT_PUBLIC_STRIPE_PRO_MONTHLY_PLAN_ID,
    NEXT_PUBLIC_STRIPE_PRO_YEARLY_PLAN_ID:
      process.env.NEXT_PUBLIC_STRIPE_PRO_YEARLY_PLAN_ID,
    NEXT_PUBLIC_STRIPE_BUSINESS_MONTHLY_PLAN_ID:
      process.env.NEXT_PUBLIC_STRIPE_BUSINESS_MONTHLY_PLAN_ID,
    NEXT_PUBLIC_STRIPE_BUSINESS_YEARLY_PLAN_ID:
      process.env.NEXT_PUBLIC_STRIPE_BUSINESS_YEARLY_PLAN_ID,
    // S3
    AWS_ENDPOINT_URL_S3: process.env.AWS_ENDPOINT_URL_S3,
    AWS_ACCESS_KEY_ID: process.env.AWS_ACCESS_KEY_ID,
    AWS_SECRET_ACCESS_KEY: process.env.AWS_SECRET_ACCESS_KEY,
    AWS_REGION: process.env.AWS_REGION,
    AWS_BUCKET_NAME: process.env.AWS_BUCKET_NAME,
  },
  skipValidation: !!process.env.SKIP_ENV_VALIDATION,
  emptyStringAsUndefined: true,
});
